<template>
  <div class="layout-blog-post-page">
    <div class="container">
      <div class="header">
        <slot name="breadcrumbs"></slot>
        <div class="title s-65 font-palantino">
          <slot name="title"></slot>
        </div>
        <!--  -->
        <div class="about">
          <div class="s-14 w-500"><slot name="date"></slot></div>
          <div class="s-14 w-500"><icon-eye></icon-eye> <slot name="views"></slot></div>
        </div>
        <!--  -->
        <div class="image">
          <slot name="image"></slot>
        </div>
      </div>
      <!--  -->
      <div class="content">
        <slot></slot>
      </div>
    </div>
    <div class="more">
      <div class="container">
        <div class="more-title s-36 w-600">Вам также будет интересно</div>
      </div>
      <slot name="more"></slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    'icon-eye': () => import('@/components/icon/icon-eye.vue')
  }
}
</script>

<style lang="scss" scoped>
.layout-blog-post-page {
  padding: 3em 0;
  margin-bottom: 30px;
}
.header {
  text-align: center;
}
.title {
  margin-top: 20px;
  * {
    font: inherit;
  }
}
.about {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  gap: 30px;
}
.image {
  position: relative;
  height: 500px;
  overflow: hidden;
  border-radius: 7px;
  margin: 50px 0;
  * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: flex-start;
  gap: 80px;
  .detail-content {
    grid-column: 1 / 3;
    grid-row: 1/2;
  }
  .detail-menu {
    grid-column: 3 / 4;
    grid-row: 1/2;
    position: sticky;
    top: 150px;
    background: var(--light);
    border-radius: 10px;
    padding: 20px;
    li {
      list-style: none;
      margin-bottom: 5px;
      a {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .detail-menu-head {
      font-weight: 600;
      margin-bottom: 10px;
    }
  }
}
.detail-content {
  & > * {
    font-size: 18px;
    line-height: 160%;
  }
}
.more {
  text-align: center;
  margin-top: 30px;
  padding-top: 30px;
  border-top: solid 1px var(--light);
  &-title {
    margin-bottom: 40px;
  }
}
@media screen and (max-width: 767px) {
  .title {
    font-size: 36px;
  }
  .header {
    padding: 0 15px;
  }
  .image {
    margin: 20px 0;
    height: 200px;
  }
  .content {
    display: block;
    padding: 0 15px;
    .detail-menu {
      margin-bottom: 15px;
      position: relative;
      top: unset;
    }
  }
}
</style>
